import React from 'react';

const NotificationTrigger = ({ text, disabled, className }) => (
  <span
    className={`notification-trigger ${
      disabled ? 'notification-trigger--disabled' : ''
    } ${className || ''}`}>
    <button disabled={disabled} aria-hidden={true}>
      {text}
    </button>
  </span>
);

export const Dagger = props => <NotificationTrigger text="†" {...props} />;

export const DoubleDagger = props => (
  <NotificationTrigger text="‡" {...props} />
);

export const Asterisk = props => <NotificationTrigger text="*" {...props} />;

export const Carrot = props => <NotificationTrigger text="^" {...props} />;

export default NotificationTrigger;
